<template>
    <div>
        <div class=" flex justify-center space-x-2 text-sm md:text-base px-2 py-2 text-center mb-2
      shadow-sm broder-bottom bg-namasteGreen">
         <!-- <p class="px-2 py-3 font-semibold text-gray-900 text-2xl ">
            Warenkorb {{ totalCartItems}} </p> -->
            <span class="my-auto  text-2xl text-warmGray-50 font-bold ">  Basket </span>
       <btn class="m-auto"
              :cartIcon="true"
              :totalCartItems="totalCartItems"
              :hasProduct="hasProduct()"
             >
               </btn>
      </div>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
import Btn from '@/components/Btn.vue'

export default {
  computed: {
    ...mapGetters({
      totalCartItems: 'getTotalCartItems'
    })
  },
  methods: {
    hasProduct () {
      return this.totalCartItems > 0
    }
  },
  components: {
    Btn
  }
}
</script>
